import { CALL_API } from 'redux-api-middleware'

export const CLIENT_LIST_REQUEST = 'clientList/CLIENT_LIST_REQUEST'
export const CLIENT_LIST_RECEIVE = 'clientList/CLIENT_LIST_RECEIVE'
export const CLIENT_LIST_FAILURE = 'clientList/CLIENT_LIST_FAILURE'

const initialState = {
  clientList: []
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CLIENT_LIST_RECEIVE:
      let clients = action.payload.data.items
      let { applicationIds, paAdmin, whitelist } = action.meta

      if (paAdmin.length > 0 && !whitelist.includes('TECH_NAUTH-ADMIN')) {
        // User is Nord employee (non-nauth), check to see what apps they should have access to
        clients = clients.filter(client => paAdmin.some(groupId => {
          return client.appAdminGroups.some(adminGroupId => adminGroupId === groupId)
        }))
      } else if (applicationIds && applicationIds.length > 0) {
        // User is non-Nord, filter apps they aren't assigned to
        clients = clients.filter(client => applicationIds.some(appId => appId === client.id))
      }

      return {
        ...state,
        clientList: clients
      }
    default:
      return state
  }
}

export function fetchClientList() {
  return (dispatch, getState) => {
    const { applicationIds, paAdmin, whitelist } = getState().authProfile
    return dispatch({
      [CALL_API]: {
        endpoint: isLocal() ? 'http://localhost:8080/api/v1/authz/applications' :
          '/api/v1/authz/applications',
        method: 'GET',
        credentials: 'include',
        types: [
          CLIENT_LIST_REQUEST,
          {
            type: CLIENT_LIST_RECEIVE,
            meta: { applicationIds, paAdmin, whitelist }
          },
          CLIENT_LIST_FAILURE
        ]
      }
    })
  }
}

function isLocal() {
  return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
}

export default reducer
